import { Component, DOCUMENT, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Subject, filter, takeUntil } from 'rxjs';

import { MobiUiFaviconService } from '@mobi/rwc-ui-components-ng-jslib';
import { TranslationService } from '@mobi/rwc-utils-ng-jslib';

import * as translationDe from './app.translation.de.json';
import * as translationFr from './app.translation.fr.json';
import * as translationIt from './app.translation.it.json';
import { TranslationToggleService } from './shared/translation/translation.toggle.service';
import { detectCoreLanguage } from './state/actions/core.actions';
import { selectLanguageAndPortal } from './state/selectors/core.selectors';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
    private translationService = inject(TranslationService);
    private store = inject(Store);
    private title = inject(Title);
    private translationToggleService = inject(TranslationToggleService);
    private document = inject<Document>(DOCUMENT);
    private faviconService = inject(MobiUiFaviconService);

    private destroy$ = new Subject();

    @HostListener('window:keydown', ['$event'])
    onDocumentKeydown(event: KeyboardEvent) {
        if (event.code === 'KeyT' && (event.ctrlKey || event.metaKey)) {
            this.translationToggleService.toggle();
        }
    }

    ngOnInit() {
        this.translationService.setTranslations({
            de: translationDe,
            fr: translationFr,
            it: translationIt,
        });
        this.translationService
            .translate('osm.app.heading')
            .pipe(takeUntil(this.destroy$))
            .subscribe(t => this.title.setTitle(t));
        this.store.dispatch(detectCoreLanguage());
        this.store
            .select(selectLanguageAndPortal)
            .pipe(
                takeUntil(this.destroy$),
                filter(() => !!this.document?.documentElement),
            )
            .subscribe(next => {
                this.faviconService.setFavicon(next.portal === 'protekta' ? 'protekta' : 'mobi');
                this.document.documentElement.lang = next.language;
            });
    }

    ngOnDestroy() {
        this.destroy$.next(undefined);
        this.destroy$.complete();
    }
}
